import { Component, inject } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { PanelModule } from '../../../modules/panel.module';
import { HqService } from '../../../services/hq.service';

@Component({
  selector: 'brt-hq-list',
  standalone: true,
  imports: [PanelModule],
  providers: [ConfirmationService],
  templateUrl: './hq-list.component.html',
  styleUrl: './hq-list.component.scss'
})
export class HqListComponent {
  private hqService = inject(HqService);
  private confirmationService = inject(ConfirmationService);

  loading: boolean = true;
  hqs: any[] = [];
  total: number;
  criteria: any;

  async filter(event?: any) {
    this.loading = true;
    try {
      event = { ...{ first: this.criteria?.From || 0, rows: this.criteria?.Size || 20 }, ...(event || {}) };
      const query = event.filters?.query?.value?.trim();
      this.criteria = { IsDisabled: null, IsDeleted: null, Query: query, From: event.first, Size: event.rows };
      await this.load();
    } finally { this.loading = false; }
  }

  private async load() {
    this.loading = true;
    let result = await this.hqService.search(this.criteria);
    this.hqs = result.List;
    this.total = result.Total;
    this.hqs.forEach(hq => {
      hq._actions = [
        { label: 'Edit', icon: 'pi pi-fw pi-pencil', routerLink: ['/hq', hq.Id] },
        { label: 'Delete', icon: 'pi pi-fw pi-trash', command: () => this.deleteHq(hq) }
      ];
    });
    this.loading = false;
  }

  deleteHq(hq: any) {
    this.confirmationService.confirm({
      key: 'confirmPopup',
      target: document.getElementById('action-menu-' + hq.Id),
      message: 'Are you sure that you want to delete this HQ?',
      icon: 'pi pi-exclamation-triangle',
      accept: async () => {
        await this.hqService.delete(hq.Id);
        await this.load();
      }
    });
  }
}
